const boundButtons = new WeakSet();

const getRequestAnimationFrame = (doc) => {
    const win = doc.defaultView || (typeof window !== 'undefined' ? window : null);
    return win?.requestAnimationFrame
        ? win.requestAnimationFrame.bind(win)
        : (cb) => setTimeout(cb, 16);
};

const animateHeight = (element, fromHeight, toHeight, time, callback, doc) => {
    let start = null;
    element.style.height = `${fromHeight}px`;
    const raf = getRequestAnimationFrame(doc);

    const step = (timestamp) => {
        if (!start) start = timestamp;
        const progress = timestamp - start;
        const currentHeight = fromHeight + (toHeight - fromHeight) * (progress / time);

        if (progress < time) {
            element.style.height = `${currentHeight}px`;
            raf(step);
        } else {
            element.style.height = `${toHeight}px`;
            callback?.();
        }
    };

    raf(step);
};

export default function (doc, { id: accordionId, animationTime = 300 } = {}) {
    if (!doc || !accordionId) return;

    const updateToggleButton = (button, expanded) => {
        if (!button) return;
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        const icon = button.querySelector('.accordion-icon');
        if (icon) {
            icon.classList.toggle('rotate-180', expanded);
        }
    };

    const closeOtherItems = (accordion, targetCollapse, doc) => {
        accordion.querySelectorAll('.acc-collapse.acc-show').forEach((openCollapse) => {
            if (openCollapse === targetCollapse) return;

            const item = openCollapse.closest('.one-accordion-body');
            const button = item?.querySelector('[data-toggle="collapse"]');
            updateToggleButton(button, false);

            animateHeight(openCollapse, openCollapse.scrollHeight, 0, animationTime, () => {
                openCollapse.classList.remove('acc-show');
                openCollapse.style.height = '';
                updateToggleButton(button, false);
            }, doc);
        });
    };

    const onAccordionHeaderClick = function () {
        const accordion = this.closest('.accordion.sio-accordion');
        if (!accordion || (accordionId && accordion.id !== accordionId)) return;

        const item = this.closest('.one-accordion-body');
        const collapse = item?.querySelector('.acc-collapse');
        if (!collapse || !accordion.contains(collapse)) return;

        const isExpanded = collapse.classList.contains('acc-show');

        if (isExpanded) {
            animateHeight(collapse, collapse.scrollHeight, 0, animationTime, () => {
                collapse.classList.remove('acc-show');
                collapse.style.height = '';
                updateToggleButton(this, false);
            }, doc);
        } else {
            const allowMultiple =
                accordion.getAttribute('data-allow-multiple-open') === 'true';
            if (!allowMultiple) {
                closeOtherItems(accordion, collapse, doc);
            }
            collapse.classList.add('acc-show');
            updateToggleButton(this, true);
            animateHeight(collapse, 0, collapse.scrollHeight, animationTime, () => {
                collapse.style.height = '';
            }, doc);
        }
    };

    doc.querySelectorAll(`#${accordionId} [data-toggle="collapse"]`).forEach((button) => {
        if (!boundButtons.has(button)) {
            button.addEventListener('click', onAccordionHeaderClick);
            boundButtons.add(button);
        }
    });
}
